// import React, { useEffect, useState, useRef } from 'react';
// import axios from 'axios';
// import apiUrl from '../../Environment/Api';
// import jsPDF from 'jspdf';
// import 'jspdf-autotable';
// import { CSVLink } from 'react-csv';
// import { CopyToClipboard } from 'react-copy-to-clipboard';
// import * as XLSX from 'xlsx';
// import { useNavigate } from 'react-router-dom';
// import logo from '../../../assets/img/Admin/Logo.png';

// function Projectreport() {
//     const navigate = useNavigate();
//     const tableRef = useRef(null);
//     const [originalData, setOriginalData] = useState([]);
//     const [filteredData, setFilteredData] = useState([]);
//     const [copied, setCopied] = useState(false);
//     const [exchangeRate, setExchangeRate] = useState(85);

//     const getdata = async () => {
//         try {
//             const response = await axios.get(apiUrl + '/invoicelist');
//             console.log("API Response:", response);
//             console.log("Data Length:", response.data.length);
//             setOriginalData(response.data);
//             setFilteredData(response.data);
//             console.log(filteredData)
//         } catch (error) {
//             console.log("Error fetching data:", error);
//         }
//     };

//     const [getclientdetails, setclientdetails] = useState([])
//     const clientdetails = async () => {
//         try {
//             const response = await axios.get(apiUrl + '/clientdetails');
//             setclientdetails(response.data);
//         }
//         catch (error) {
//             console.log(error)
//         }
//     }


//     useEffect(() => {
//         getdata();
//         clientdetails();
//     }, []);

//     const handlesearchFilter = (e) => {
//         e.preventDefault();
//         const inputValue = e.target.value.trim().toLowerCase();
//         const filteredData = originalData.filter((data) =>
//             Object.values(data).some(
//                 (value) =>
//                     value.toString().toLowerCase().includes(inputValue)
//             )
//         );

//         setFilteredData(filteredData);
//     };

//     useEffect(() => {
//         const fetchExchangeRate = async () => {
//             try {
//                 const response = await fetch(
//                     "https://api.frankfurter.app/latest?from=USD&to=INR"
//                 );
//                 const data = await response.json();
//                 setExchangeRate(data.rates.INR);
//             } catch (error) {
//                 console.error("Error fetching exchange rate:", error);
//                 setExchangeRate(85); // Fallback rate
//             }
//         };
//         fetchExchangeRate();
//     }, []);


//     const generatePDF = () => {
//         const pdf = new jsPDF();

//         // Load your logo image
//         const logoImage = new Image();
//         logoImage.src = logo;

//         const logoWidth = 25;
//         const logoHeight = 25;

//         // Add logo image to the PDF on the left side
//         pdf.addImage(logoImage, 'PNG', 15, 5, logoWidth, logoHeight);

//         // Add information on the right end
//         const rightEndX = pdf.internal.pageSize.getWidth() - 10;
//         const rightEndY = 0; // Adjust the Y-coordinate as needed

//         // Font size for text
//         const fontSize = 8;

//         // Margin top for text content
//         const marginTopText = 8;

//         // FontAwesome icons
//         const faAddress = 'f095'; // FontAwesome icon for address

//         // Add sample words with text and FontAwesome icons
//         pdf.setFontSize(fontSize);
//         pdf.text(rightEndX - 50, rightEndY + marginTopText + 4, 'VAS Post Production');
//         pdf.text(rightEndX - 50, rightEndY + marginTopText + 8, 'Vasanthan. K');
//         pdf.text(rightEndX - 50, rightEndY + marginTopText + 12, `87, Kamarajar Nagar,\nDadagapatti,\nSalem-6`);

//         const marginTop = 35;
//         pdf.autoTable({ html: tableRef.current, startY: marginTop });

//         pdf.save('Reports.pdf');
//     };


//     const generateExcel = () => {
//         // Remove the 'id' column and add a new 'S No.' column
//         const dataWithoutId = filteredData.map((data, index) => {
//             const { id, ...rest } = data;
//             return { 'S No.': index + 1, ...rest };
//         });

//         const header = Object.keys(dataWithoutId[0]);
//         const rows = dataWithoutId.map(data => Object.values(data));

//         const ws = XLSX.utils.aoa_to_sheet([header, ...rows]);
//         const wb = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(wb, ws, 'Reports');

//         XLSX.writeFile(wb, 'Reports.xlsx');
//     };

//     const copyToClipboard = () => {
//         setCopied(true);
//         setTimeout(() => setCopied(false), 1500);
//     };

//     const handletoprint = () => {
//         navigate('/reportprint')
//     }




//     const [selectedproject, setSelectedproject] = useState('');
//     const [selectedinvoiceid, setSelectedinvoiceid] = useState('');
//     const [fromDate, setFromDate] = useState('');
//     const [toDate, setToDate] = useState('');

//     const handleFilterClick = (e) => {
//         e.preventDefault();
//         let newData = originalData.slice();
//         if (selectedproject && selectedproject !== "All Client") {
//             newData = newData.filter((data) => data.clientName === selectedproject);
//         }
//         if (selectedproject === "All Client") {
//         }
//         if (selectedinvoiceid) {
//             newData = newData.filter((data) => data.type === selectedinvoiceid);
//         }
//         if (fromDate && toDate) {
//             newData = newData.filter((data) => {
//                 const dataDate = new Date(data.date);
//                 const fromDateTime = new Date(fromDate);
//                 const toDateTime = new Date(toDate);

//                 return dataDate >= fromDateTime && dataDate <= toDateTime;
//             });
//         }
//         setFilteredData(newData);
//     };


//     const getUniqueTypes = (client) => {
//         let filteredDataForProject = originalData;
//         if (client) {
//             filteredDataForProject = originalData.filter((data) => data.clientName === client);
//         }
//         const types = [...new Set(filteredDataForProject.map((data) => data.type))];
//         return types;
//     };




//     const getUniqueClientNames = () => {
//         const uniqueClientNames = [...new Set(originalData.map((data) => data.clientName))];
//         return uniqueClientNames;
//     };


//     //pagination
//     const [currentPage, setCurrentPage] = useState(1);
//     const [itemsPerPage, setItemsPerPage] = useState(20);

//     const indexOfLastItem = currentPage * itemsPerPage;
//     const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//     const currentItems = filteredData.slice().reverse().slice(indexOfFirstItem, indexOfLastItem);

//     const paginate = (pageNumber) => setCurrentPage(pageNumber);

//     const handleItemsPerPageChange = (e) => {
//         setCurrentPage(1);
//         setItemsPerPage(Number(e.target.value));
//     };


//     const clearFilters = (e) => {
//         e.preventDefault();
//         setSelectedproject('');
//         setSelectedinvoiceid('');
//         setFromDate('');
//         setToDate('');
//         setFilteredData(originalData);
//     };


//     const printTable = () => {
//         const printWindow = window.open('', '_blank');
//         printWindow.document.write('<html><head><title>Print</title>');
//         printWindow.document.write('<style type="text/css">');
//         printWindow.document.write(`
//           body {
//             text-align: center;
//           }
      
//           h1 {
//             margin-top: 20px;
//           }
      
//           table {
//             border-collapse: collapse;
//             width: 100%;
//             margin-top: 20px;
//           }
      
//           table, th, td {
//             border: 1px solid black;
//           }
      
//           th, td {
//             padding: 10px;
//             text-align: left;
//           }
//         `);
//         printWindow.document.write('</style></head><body>');

//         // Centered heading
//         printWindow.document.write('<h1>Project Reports</h1>');

//         // Check if the element with ID 'table-container' exists before accessing its innerHTML
//         const tableContainer = document.getElementById('table-container');
//         if (tableContainer) {
//             // Add your table to the print window
//             printWindow.document.write(tableContainer.innerHTML);
//         } else {
//             console.error("Element with ID 'table-container' not found");
//         }

//         printWindow.document.write('</body></html>');

//         setTimeout(() => {
//             printWindow.print();
//             // Close the print window after printing
//             printWindow.close();
//         }, 1000);
//     };


//     const formatDate = (dateString) => {
//         if (!dateString || dateString === "Invalid Date") {
//             return ""; // Return empty string for invalid or empty dates
//         }

//         const date = new Date(dateString);
//         const formattedDate = date.toLocaleDateString('en-GB', {
//             day: '2-digit',
//             month: '2-digit',
//             year: 'numeric',
//         }).replace(/\//g, '-'); // Replace slashes with hyphens

//         return formattedDate;
//     };
//     return (
//         <>
//             <div>
//                 <div className='card cardshadow'>
//                     <div className="text-center">
//                         <h5 className="mt-2">Project Reports</h5>
//                     </div>
//                     <hr />

//                     <div>
//                         <form className='projectfilter-wrap p-3'>
//                             <div className='mx-3 dropdown'>
//                                 <label className='form-label'>Client Name</label>
//                                 <div className="position-relative">
//                                     <select
//                                         className='form-control dropdown-toggle custom-select'
//                                         value={selectedproject}
//                                         onChange={(e) => {
//                                             const selectedValue = e.target.value;
//                                             setSelectedproject(selectedValue);
//                                             setSelectedinvoiceid('');
//                                             if (selectedValue === "") {
//                                                 setSelectedproject("");
//                                             }
//                                         }}
//                                     >
//                                         <option value="" disabled>Select Client</option>
//                                         <option value="All Client">All Client</option>
//                                         {getUniqueClientNames().map((clientName, index) => (
//                                             <option
//                                                 key={index}
//                                                 value={clientName}

//                                             >
//                                                 {clientName}
//                                             </option>
//                                         ))}
//                                     </select>
//                                     <div className="dropdown-arrow"></div>
//                                 </div>
//                             </div>
//                             {/* <div className='mx-3 dropdown'>
//                                 <label className='form-label'>Type</label>
//                                 <div className="position-relative">
//                                     <select
//                                         className='form-control dropdown-toggle custom-select'
//                                         value={selectedinvoiceid}
//                                         onChange={(e) => setSelectedinvoiceid(e.target.value)}
//                                     >
//                                         <option value="" disabled>Select Type</option>
//                                         {selectedproject === "All Client" ?
//                                             getUniqueTypes().map((type, index) => (
//                                                 <option key={index} value={type}>
//                                                     {type}
//                                                 </option>
//                                             )) :
//                                             getUniqueTypes(selectedproject).map((type, index) => (
//                                                 <option key={index} value={type}>
//                                                     {type}
//                                                 </option>
//                                             ))
//                                         }
//                                     </select>
//                                     <div className="dropdown-arrow"></div>
//                                 </div>
//                             </div> */}
//                             <div className='mx-3'>
//                                 <label className='form-label'>From Date</label>
//                                 <input
//                                     type='date'
//                                     className='form-control'
//                                     value={fromDate}
//                                     onChange={(e) => setFromDate(e.target.value)}
//                                 />
//                             </div>
//                             <div className='mx-3'>
//                                 <label className='form-label'>To Date</label>
//                                 <input
//                                     type='date'
//                                     className='form-control'
//                                     value={toDate}
//                                     onChange={(e) => setToDate(e.target.value)}
//                                 />
//                             </div>
//                             <div className='mx-3'>
//                                 <button onClick={handleFilterClick} className='btn btn-primary filterbutton'><i className="fa-solid fa-filter"></i></button>
//                                 <button onClick={clearFilters} className='btn btn-secondary clearbutton mx-2'>clear</button>
//                             </div>
//                         </form>

//                     </div>
//                 </div>
//                 <div className='d-flex justify-content-between '>
//                     <form className='seach-content'>
//                         <label>Show per page:</label>
//                         <select className='form-control' value={itemsPerPage} onChange={handleItemsPerPageChange}>
//                             <option value={5}>5</option>
//                             <option value={10}>10</option>
//                             <option value={20}>20</option>
//                             <option value={50}>50</option>
//                             <option value={100}>100</option>
//                             <option value={200}>200</option>
//                             <option value={500}>500</option>
//                         </select>
//                     </form>
//                     <div className='button-save' style={{ height: '20px' }}>
//                         <CopyToClipboard text={JSON.stringify(filteredData)} onCopy={copyToClipboard}>
//                             <button className='btn btn-sm btn-secondary mx-1'>
//                                 {copied ? 'Copied!' : 'Copy'}
//                             </button>
//                         </CopyToClipboard>
//                         <CSVLink data={filteredData} filename={'Reports.csv'}>
//                             <button className='btn btn-sm btn-secondary mx-1'>CSV</button>
//                         </CSVLink>
//                         <button className="btn btn-sm btn-secondary mx-1" onClick={generateExcel}>
//                             Excel
//                         </button>
//                         <button className='btn btn-sm btn-secondary mx-1' onClick={generatePDF}>
//                             PDF
//                         </button>
//                         <button className='btn btn-sm btn-secondary mx-1' onClick={printTable}>Print</button>
//                     </div>
//                     <form className='seach-content'>
//                         <label>Search :</label>
//                         <input className='form-control' type='text' onChange={handlesearchFilter}></input>
//                     </form>
//                 </div>
//                 <div id="table-container" className='table-responsive'>
//                     <table ref={tableRef} class="table table-striped">
//                         <thead>
//                             <tr className='tr-heading'>
//                                 <th>S.No</th>
//                                 <th>Client Name</th>
//                                 <th>Date</th>
//                                 <th>Project Name</th>
//                                 {/* <th>Type</th>
//                                 <th>Qty</th> */}
//                                 <th>Standard</th>
//                                 <th>Premier</th>
//                                 <th>Twilight</th>
//                                 <th>day_to_dusk</th>
//                                 <th>Vra</th>
//                                 <th>Vr</th>
//                                 <th>Price</th>
//                                 <th>Paypal Tax(%)</th>
//                                 <th>Total Amount</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {currentItems.map((data, index) => (
//                                 <tr key={index} className="tr-shadow">
//                                     <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
//                                     <td>{data.clientName}</td>
//                                     <td>{formatDate(data.date)}</td>
//                                     <td>{data.projectName}</td>
//                                     {/* <td>{data.type}</td>
//                                     <td>{data.quantity}</td> */}
//                                     <td>{data.standard}</td>
//                                     <td>{data.premier}</td>
//                                     <td>{data.twilight}</td>
//                                     <td>{data.day_to_dusk}</td>
//                                     <td>{data.vra}</td>
//                                     <td>{data.vr}</td>
//                                     <td>{data.price}</td>
//                                     <td>{data.tax}</td>
//                                     {/* <td>{data.totalAmount}</td> */}
//                                     {/* <td>$ {data.totalAmount}</td> */}
//                                     {/* <td>
//                                         {(() => {
//                                             const clientData = getclientdetails.find(client => client.id === data.clientId);

//                                             if (clientData) {
//                                                 const currencySymbol = clientData.countrycode === '91' ? 'INR' : '$';
//                                                 return (
//                                                     <span>
//                                                         {currencySymbol} {Number(data.totalAmount).toFixed(2)}
//                                                     </span>
//                                                 );
//                                             }
//                                             return null;
//                                         })()}
//                                     </td> */}
//                                     <td>
//                                         {(() => {
//                                             const clientData = getclientdetails.find(client => client.id === data.clientId);

//                                             if (clientData) {
//                                                 const isIndian = clientData.countrycode === '91';
//                                                 const currencySymbol = isIndian ? '₹' : '$';

//                                                 // Convert from USD to INR if Indian client
//                                                 const totalAmountUSD = Number(data.totalAmount);
//                                                 const displayAmount = isIndian ? totalAmountUSD * exchangeRate : totalAmountUSD;

//                                                 return (
//                                                     <span>
//                                                         {currencySymbol} {displayAmount.toFixed(2)}
//                                                     </span>
//                                                 );
//                                             }
//                                             return null;
//                                         })()}
//                                     </td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 </div>
//                 <div>
//                     <nav className='d-flex justify-content-end mx-2 pt-4'>
//                         <ul className="pagination">
//                             <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
//                                 <button className="page-link mx-3" onClick={() => paginate(currentPage - 1)}>
//                                     Previous
//                                 </button>
//                             </li>
//                             {Array.from({ length: Math.ceil(filteredData.length / itemsPerPage) }, (_, index) => (
//                                 <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
//                                     <button className="page-link" onClick={() => paginate(index + 1)}>
//                                         {index + 1}
//                                     </button>
//                                 </li>
//                             ))}
//                             <li className={`page-item ${currentPage === Math.ceil(filteredData.length / itemsPerPage) ? 'disabled' : ''}`}>
//                                 <button className="page-link mx-3" onClick={() => paginate(currentPage + 1)}>
//                                     Next
//                                 </button>
//                             </li>
//                         </ul>
//                     </nav>
//                 </div>
//             </div>
//         </>

//     )
// }
// export default Projectreport;


import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import apiUrl from '../../Environment/Api';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { CSVLink } from 'react-csv';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import * as XLSX from 'xlsx';
import { useNavigate } from 'react-router-dom';
import logo from '../../../assets/img/Admin/Logo.png';

function Projectreport() {
    const navigate = useNavigate();
    const tableRef = useRef(null);
    const [originalData, setOriginalData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [copied, setCopied] = useState(false);
    const [exchangeRate, setExchangeRate] = useState(85);
    const [columnConfigs, setColumnConfigs] = useState({});

    // All 12 columns - will always be displayed
    const allColumns = ['standard', 'premier', 'twilight', 'day_to_dusk', 'vra', 'vr', 'col7', 'col8', 'col9', 'col10', 'col11', 'col12'];

    const getdata = async () => {
        try {
            const response = await axios.get(apiUrl + '/invoicelist');
            console.log("API Response:", response);
            console.log("Data Length:", response.data.length);
            setOriginalData(response.data);
            setFilteredData(response.data);
            
            // After getting data, fetch column configs for all unique invoices
            const uniqueInvoiceIds = [...new Set(response.data.map(item => item.invoiceId))];
            fetchAllColumnConfigs(uniqueInvoiceIds);
        } catch (error) {
            console.log("Error fetching data:", error);
        }
    };

    // Fetch column configurations for all invoices
    const fetchAllColumnConfigs = async (invoiceIds) => {
        const configs = {};
        
        for (const invoiceId of invoiceIds) {
            try {
                const response = await axios.get(apiUrl + `/invoice-columns/${invoiceId}`);
                console.log(`Column config for ${invoiceId}:`, response.data);
                
                // Backend returns { status: 'success', data: {...} }
                if (response.data && response.data.status === 'success' && response.data.data) {
                    configs[invoiceId] = response.data.data;
                }
            } catch (error) {
                console.log(`Error fetching column config for ${invoiceId}:`, error);
            }
        }
        
        setColumnConfigs(configs);
        console.log("All column configs loaded:", configs);
    };

    const [getclientdetails, setclientdetails] = useState([])
    const clientdetails = async () => {
        try {
            const response = await axios.get(apiUrl + '/clientdetails');
            setclientdetails(response.data);
        }
        catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getdata();
        clientdetails();
    }, []);

    // Get column name from database for specific invoice
    const getColumnName = (invoiceId, columnKey) => {
        const config = columnConfigs[invoiceId];
        
        // If we have config for this invoice and column
        if (config && config[columnKey] && config[columnKey].trim() !== "") {
            return config[columnKey];
        }
        
        // Fallback to default names
        const defaultNames = {
            standard: "Standard",
            premier: "Premier",
            twilight: "Twilight",
            day_to_dusk: "Day to Dusk",
            vra: "VRA",
            vr: "VR",
            col7: "Column 7",
            col8: "Column 8",
            col9: "Column 9",
            col10: "Column 10",
            col11: "Column 11",
            col12: "Column 12"
        };
        return defaultNames[columnKey] || columnKey;
    };

    // Format as "ColumnName-Value"
    const formatColumnDisplay = (invoiceId, columnKey, value) => {
        if (!value || value === "" || value === "0") {
            return "";
        }
        
        const columnName = getColumnName(invoiceId, columnKey);
        return `${columnName}-${value}`;
    };

    const handlesearchFilter = (e) => {
        e.preventDefault();
        const inputValue = e.target.value.trim().toLowerCase();
        const filteredData = originalData.filter((data) =>
            Object.values(data).some(
                (value) =>
                    value.toString().toLowerCase().includes(inputValue)
            )
        );

        setFilteredData(filteredData);
    };

    useEffect(() => {
        const fetchExchangeRate = async () => {
            try {
                const response = await fetch(
                    "https://api.frankfurter.app/latest?from=USD&to=INR"
                );
                const data = await response.json();
                setExchangeRate(data.rates.INR);
            } catch (error) {
                console.error("Error fetching exchange rate:", error);
                setExchangeRate(85);
            }
        };
        fetchExchangeRate();
    }, []);


    const generatePDF = () => {
        const pdf = new jsPDF('l', 'mm', 'a4'); // Landscape mode

        const logoImage = new Image();
        logoImage.src = logo;

        const logoWidth = 25;
        const logoHeight = 25;

        pdf.addImage(logoImage, 'PNG', 15, 5, logoWidth, logoHeight);

        const rightEndX = pdf.internal.pageSize.getWidth() - 10;
        const rightEndY = 0;

        const fontSize = 8;
        const marginTopText = 8;

        pdf.setFontSize(fontSize);
        pdf.text(rightEndX - 50, rightEndY + marginTopText + 4, 'VAS Post Production');
        pdf.text(rightEndX - 50, rightEndY + marginTopText + 8, 'Vasanthan. K');
        pdf.text(rightEndX - 50, rightEndY + marginTopText + 12, `87, Kamarajar Nagar,\nDadagapatti,\nSalem-6`);

        const marginTop = 35;
        pdf.autoTable({ html: tableRef.current, startY: marginTop });

        pdf.save('Reports.pdf');
    };


    const generateExcel = () => {
        const dataForExcel = filteredData.map((data, index) => {
            const row = {
                'S No.': index + 1,
                'Client Name': data.clientName,
                'Date': formatDate(data.date),
                'Project Name': data.projectName
            };

            // Add all 12 columns with their custom names
            allColumns.forEach(col => {
                const columnName = getColumnName(data.invoiceId, col);
                const displayValue = formatColumnDisplay(data.invoiceId, col, data[col]);
                row[columnName] = displayValue || data[col] || '';
            });

            row['Price'] = data.price;
            row['Paypal Tax(%)'] = data.tax;
            
            const clientData = getclientdetails.find(client => client.id === data.clientId);
            if (clientData) {
                const isIndian = clientData.countrycode === '91';
                const currencySymbol = isIndian ? '₹' : '$';
                const totalAmountUSD = Number(data.totalAmount);
                const displayAmount = isIndian ? totalAmountUSD * exchangeRate : totalAmountUSD;
                row['Total Amount'] = `${currencySymbol} ${displayAmount.toFixed(2)}`;
            }

            return row;
        });

        const ws = XLSX.utils.json_to_sheet(dataForExcel);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Reports');

        XLSX.writeFile(wb, 'Reports.xlsx');
    };

    const copyToClipboard = () => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
    };

    const handletoprint = () => {
        navigate('/reportprint')
    }

    const [selectedproject, setSelectedproject] = useState('');
    const [selectedinvoiceid, setSelectedinvoiceid] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');

    const handleFilterClick = (e) => {
        e.preventDefault();
        let newData = originalData.slice();
        if (selectedproject && selectedproject !== "All Client") {
            newData = newData.filter((data) => data.clientName === selectedproject);
        }
        if (selectedproject === "All Client") {
        }
        if (selectedinvoiceid) {
            newData = newData.filter((data) => data.type === selectedinvoiceid);
        }
        if (fromDate && toDate) {
            newData = newData.filter((data) => {
                const dataDate = new Date(data.date);
                const fromDateTime = new Date(fromDate);
                const toDateTime = new Date(toDate);

                return dataDate >= fromDateTime && dataDate <= toDateTime;
            });
        }
        setFilteredData(newData);
    };


    const getUniqueTypes = (client) => {
        let filteredDataForProject = originalData;
        if (client) {
            filteredDataForProject = originalData.filter((data) => data.clientName === client);
        }
        const types = [...new Set(filteredDataForProject.map((data) => data.type))];
        return types;
    };

    const getUniqueClientNames = () => {
        const uniqueClientNames = [...new Set(originalData.map((data) => data.clientName))];
        return uniqueClientNames;
    };

    //pagination
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(20);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice().reverse().slice(indexOfFirstItem, indexOfLastItem);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const handleItemsPerPageChange = (e) => {
        setCurrentPage(1);
        setItemsPerPage(Number(e.target.value));
    };

    const clearFilters = (e) => {
        e.preventDefault();
        setSelectedproject('');
        setSelectedinvoiceid('');
        setFromDate('');
        setToDate('');
        setFilteredData(originalData);
    };

    const printTable = () => {
        const printWindow = window.open('', '_blank');
        printWindow.document.write('<html><head><title>Print</title>');
        printWindow.document.write('<style type="text/css">');
        printWindow.document.write(`
          body {
            text-align: center;
          }
      
          h1 {
            margin-top: 20px;
          }
      
          table {
            border-collapse: collapse;
            width: 100%;
            margin-top: 20px;
          }
      
          table, th, td {
            border: 1px solid black;
          }
      
          th, td {
            padding: 10px;
            text-align: left;
          }
        `);
        printWindow.document.write('</style></head><body>');

        printWindow.document.write('<h1>Project Reports</h1>');

        const tableContainer = document.getElementById('table-container');
        if (tableContainer) {
            printWindow.document.write(tableContainer.innerHTML);
        } else {
            console.error("Element with ID 'table-container' not found");
        }

        printWindow.document.write('</body></html>');

        setTimeout(() => {
            printWindow.print();
            printWindow.close();
        }, 1000);
    };

    const formatDate = (dateString) => {
        if (!dateString || dateString === "Invalid Date") {
            return "";
        }

        const date = new Date(dateString);
        const formattedDate = date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        }).replace(/\//g, '-');

        return formattedDate;
    };

    return (
        <>
            <div>
                <div className='card cardshadow'>
                    <div className="text-center">
                        <h5 className="mt-2">Project Reports</h5>
                    </div>
                    <hr />

                    <div>
                        <form className='projectfilter-wrap p-3'>
                            <div className='mx-3 dropdown'>
                                <label className='form-label'>Client Name</label>
                                <div className="position-relative">
                                    <select
                                        className='form-control dropdown-toggle custom-select'
                                        value={selectedproject}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            setSelectedproject(selectedValue);
                                            setSelectedinvoiceid('');
                                            if (selectedValue === "") {
                                                setSelectedproject("");
                                            }
                                        }}
                                    >
                                        <option value="" disabled>Select Client</option>
                                        <option value="All Client">All Client</option>
                                        {getUniqueClientNames().map((clientName, index) => (
                                            <option
                                                key={index}
                                                value={clientName}
                                            >
                                                {clientName}
                                            </option>
                                        ))}
                                    </select>
                                    <div className="dropdown-arrow"></div>
                                </div>
                            </div>
                            <div className='mx-3'>
                                <label className='form-label'>From Date</label>
                                <input
                                    type='date'
                                    className='form-control'
                                    value={fromDate}
                                    onChange={(e) => setFromDate(e.target.value)}
                                />
                            </div>
                            <div className='mx-3'>
                                <label className='form-label'>To Date</label>
                                <input
                                    type='date'
                                    className='form-control'
                                    value={toDate}
                                    onChange={(e) => setToDate(e.target.value)}
                                />
                            </div>
                            <div className='mx-3'>
                                <button onClick={handleFilterClick} className='btn btn-primary filterbutton'><i className="fa-solid fa-filter"></i></button>
                                <button onClick={clearFilters} className='btn btn-secondary clearbutton mx-2'>clear</button>
                            </div>
                        </form>
                    </div>
                </div>

                <div className='d-flex justify-content-between '>
                    <form className='seach-content'>
                        <label>Show per page:</label>
                        <select className='form-control' value={itemsPerPage} onChange={handleItemsPerPageChange}>
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                            <option value={200}>200</option>
                            <option value={500}>500</option>
                        </select>
                    </form>
                    <div className='button-save' style={{ height: '20px' }}>
                        <CopyToClipboard text={JSON.stringify(filteredData)} onCopy={copyToClipboard}>
                            <button className='btn btn-sm btn-secondary mx-1'>
                                {copied ? 'Copied!' : 'Copy'}
                            </button>
                        </CopyToClipboard>
                        <CSVLink data={filteredData} filename={'Reports.csv'}>
                            <button className='btn btn-sm btn-secondary mx-1'>CSV</button>
                        </CSVLink>
                        <button className="btn btn-sm btn-secondary mx-1" onClick={generateExcel}>
                            Excel
                        </button>
                        <button className='btn btn-sm btn-secondary mx-1' onClick={generatePDF}>
                            PDF
                        </button>
                        <button className='btn btn-sm btn-secondary mx-1' onClick={printTable}>Print</button>
                    </div>
                    <form className='seach-content'>
                        <label>Search :</label>
                        <input className='form-control' type='text' onChange={handlesearchFilter}></input>
                    </form>
                </div>

                <div id="table-container" className='table-responsive'>
                    <table ref={tableRef} className="table table-striped">
                        <thead>
                            <tr className='tr-heading'>
                                <th>S.No</th>
                                <th>Client Name</th>
                                <th>Date</th>
                                <th>Project Name</th>
                                
                                {/* Display ALL 12 columns with static headers col1-col12 */}
                                {allColumns.map((columnKey, index) => (
                                    <th key={columnKey}>
                                        col{index + 1}
                                    </th>
                                ))}
                                
                                <th>Price</th>
                                <th>Paypal Tax(%)</th>
                                <th>Total Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentItems.map((data, index) => (
                                <tr key={index} className="tr-shadow">
                                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                                    <td>{data.clientName}</td>
                                    <td>{formatDate(data.date)}</td>
                                    <td>{data.projectName}</td>
                                    
                                    {/* Display ALL 12 columns with ColumnName-Value format */}
                                    {allColumns.map((columnKey) => (
                                        <td key={columnKey}>
                                            {formatColumnDisplay(data.invoiceId, columnKey, data[columnKey])}
                                        </td>
                                    ))}
                                    
                                    <td>{data.price}</td>
                                    <td>{data.tax}</td>
                                    <td>
                                        {(() => {
                                            const clientData = getclientdetails.find(client => client.id === data.clientId);

                                            if (clientData) {
                                                const isIndian = clientData.countrycode === '91';
                                                const currencySymbol = isIndian ? '₹' : '$';

                                                const totalAmountUSD = Number(data.totalAmount);
                                                const displayAmount = isIndian ? totalAmountUSD * exchangeRate : totalAmountUSD;

                                                return (
                                                    <span>
                                                        {currencySymbol} {displayAmount.toFixed(2)}
                                                    </span>
                                                );
                                            }
                                            return null;
                                        })()}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div>
                    <nav className='d-flex justify-content-end mx-2 pt-4'>
                        <ul className="pagination">
                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                <button className="page-link mx-3" onClick={() => paginate(currentPage - 1)}>
                                    Previous
                                </button>
                            </li>
                            {Array.from({ length: Math.ceil(filteredData.length / itemsPerPage) }, (_, index) => (
                                <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                    <button className="page-link" onClick={() => paginate(index + 1)}>
                                        {index + 1}
                                    </button>
                                </li>
                            ))}
                            <li className={`page-item ${currentPage === Math.ceil(filteredData.length / itemsPerPage) ? 'disabled' : ''}`}>
                                <button className="page-link mx-3" onClick={() => paginate(currentPage + 1)}>
                                    Next
                                </button>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </>
    )
}
export default Projectreport;